<template>
  <div style="padding: 30px 0px">
    <section>
      <div class="title">注册或者登陆时，遇到获取验证码失败，怎么办？</div>
      <div class="block">
        <div>您可能会在获取验证码时遇到这些问题：</div>
        <div class="number">1.</div>
        <div class="text">可能是系统出现问题，您可以尝试重新获取验证码。</div>
      </div>
      <div class="block">
        <div class="number">2.</div>
        <div
          class="text"
        >可能是您过于频繁的请求验证码，您可以在2分钟后重新尝试请求。</div>
      </div>
    </section>

    <section>
      <div class="title">注册或者登陆时，输入的验证码错误或者失效怎么办？</div>
      <div class="block">
        <div>当您在注册或者登陆时，可能会遇到以下问题：</div>
        <div class="number">1.</div>
        <div class="text">提示输入的验证码错误，请检查短信中验证码与您输入的验证码是否一样。</div>
      </div>
      <div class="block">
        <div class="number">2.</div>
        <div
          class="text"
        >提示输入的验证码已过期，由于验证码在30分钟后会过期，您需要重新获取验证码并使用。</div>
      </div>
    </section>

    <section>
      <div class="title">首次登录宜家APP如何操作？</div>
      <div class="block">
        <div>宜家APP账号与宜家官网账号一致。</div>
        <div class="number">1.</div>
        <div class="text">
          未注册宜家官网账号：你需要通过手机号码和邮箱地址注册宜家帐户。
          部分原有宜家官网帐户由于长期未使用现已失效，烦请重新"注册"。
          在注册时请填写正确的常用邮箱地址，宜家将通过邮件的形式发送宜家网上商城订单电子收银条至注册邮箱。</div>
      </div>
      <div class="block">
        <div class="number">2.</div>
        <div
          class="text"
        >已注册宜家官网账号：若您已注册宜家官网账号但忘记密码，可进入登录页面，点击"忘记密码"，
          下一步输入会员卡预留的邮箱或者手机号码，系统会将你的密码发送到预留的邮箱或者短信发送至预留手机上。</div>
      </div>
    </section>

    <section>
      <div class="title">无法登录是怎么回事？</div>
      <div class="block">
        <div>无法登录可能有两种情况：</div>
        <div class="number">1.</div>
        <div class="text">可能是输入的用户名格式不正确，您可以输入手机号或者邮箱来登录。</div>
      </div>
      <div class="block">
        <div class="number">2.</div>
        <div
          class="text"
        >可能是密码不对，请注意密码字母大小写和空格，您也可以通过【忘记密码】来找回密码后重新登录。</div>
      </div>
    </section>

    <section>
      <div class="title">账号密码登录成功，提示我信息获取失败需要重新登录，是怎么回事？</div>
      <div class="block">
        <div>在获取个人信息的时候系统发生错误，重新输入账号密码再次登录即可。</div>
      </div>
    </section>

    <section>
      <div class="title">为什么登录过程中需要输入手机号验证？</div>
      <div class="block">
        <div>您的账号可能被锁定或者由于账号较老没有手机号的信息；重新输入手机号与当前账号进行绑定后，可以正常登陆哦。</div>
      </div>
    </section>

    <section>
      <div class="title">注册时提示账号已存在，怎么办？</div>
      <div class="block">
        <div>同一个Email地址，只能用来注册一个宜家账号，如您注册的账号已存在，可以直接使用该账号进行登录或者更换一个账号进行注册。</div>
      </div>
    </section>

    <section>
      <div class="title">忘记密码时，获取临时密码失败怎么办？</div>
      <div class="block">
        <div>若您忘记密码，需要您先获取临时密码，再重新设置新密码，即可正常登陆APP。
          若您在获取临时密码时，发生错误，您可以重新尝试获取。若还有更多问题，可以联系客服解决。</div>
      </div>
    </section>

    <section>
      <div class="title">输入临时密码后，为什么需要进行手机号的验证？</div>
      <div class="block">
        <div>当您的账号长时间未使用，或您的账号被锁定，或您的账号未激活，均需要您在登录时重新绑定手机号。
          您可以根据提示输入手机号和验证码，重新绑定后即可使用。</div>
      </div>
    </section>

    <div class="seperator-line"></div>
    <div class="title" style="margin:30px 0px 20px 0px; text-align:center;">如果在常见问题中没有找到答案，请联系我们</div>

    <div class="flex-space-between actions centered" style="width:170px;">
      <div class="action"  @click="goToCustomerService()">
        <div class="icon">
          <img src="@/assets/icons/support.png" class="centered">
        </div>
        <div class="">在线客服</div>
      </div>
      <div class="action" @click="goToCustomerServiceTel()">
        <div class="icon">
          <img src="@/assets/icons/phone.png" class="centered">
        </div>
        <div class="">客服热线</div>
      </div>
    </div>
  </div>
</template>

<script>
const router = require("@/libs/router");

export default {
  data() {
    return {};
  },
  methods: {
    goToCustomerService() {
      router.open('customer_service');
    },
    goToCustomerServiceTel() {
      router.open('customer_service_tel');
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  font-size: 14px;
}
section {
  padding: 0px 25px;
  margin-bottom: 30px;
}
.title {
  font-weight: bold;
}
.block {
  margin: 10px 0px;
  color: rgb(102, 102, 102);
  line-height: 22px;
  align-items: flex-start;
}
.number {
  width: 30px;
  float: left;
}
.text {
  padding-left: 30px;
}
.action {
    color: rgb(102, 102, 102);
    -webkit-tap-highlight-color:rgba(0,0,0,0);
}
.icon {
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background-color: rgb(242,242,242);
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
}

.icon img {
  padding-top: 13px;
  width: 22px;
}

.highlight {
  color: red;
  padding-left: 2px;
  padding-right: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/app/SigninSignupFAQ.vue